import Vuex from 'vuex';
import Vue from 'vue';

import auth from './modules/auth';
import common from './modules/common';
import countries from './modules/countries';
import languages from './modules/languages';
import telcodes from './modules/telcodes';
import employee from './modules/employee';
import forms from './modules/forms';
import education from './modules/education';
import attestation from './modules/attestation';
import tests from './modules/tests';
import locales from './modules/locales';
import lang from './modules/lang';
import order from './modules/order';
import tickets from './modules/tickets';
import courierRequests from './modules/courierRequests';
import orderProducts from './modules/orderProducts';
import notifications from './modules/notifications';
import recalls from './modules/recalls';
import callingList from './modules/callingList';

import usaAddresChecking from './modules/usaAddresChecking';
import calcOperatorSalary from './modules/calcOperatorSalary';

Vue.use(Vuex);

const modules = {
    auth,
    common,
    countries,
    languages,
    telcodes,
    forms,
    employee,
    education,
    attestation,
    tests,
    locales,
    lang,
    order,
    tickets,
    courierRequests,
    orderProducts,
    notifications,
    recalls,
    usaAddresChecking,
    calcOperatorSalary,
    callingList
};

export default new Vuex.Store({
    modules
});